module.exports = "pegasus/assets/blocks/column-4-theme2.png";